/**
 * `instanceof HTMLElement` & Co., auch für Knoten aus einem ausgelagerten
 * Browserfenster.
 *
 * Jedes Browserfenster hat eigene Konstruktoren. Was React im Browserfenster
 * neu anlegt, ist dort ein `HTMLElement` — aber keins des Hauptfensters, und
 * `x instanceof HTMLElement` ist dafür `false`. Dieser Helfer prüft gegen die
 * Konstruktoren des Fensters, zu dem der Knoten gehört.
 */
type DomArt =
  | "Node"
  | "Element"
  | "HTMLElement"
  | "HTMLInputElement"
  | "HTMLTextAreaElement"
  | "HTMLSelectElement"
  | "HTMLButtonElement"
  | "HTMLAnchorElement"
  | "HTMLImageElement"
  | "HTMLCanvasElement"
  | "HTMLIFrameElement"
  | "Text";

export function istDom<K extends DomArt>(x: unknown, art: K): x is InstanceType<(typeof globalThis)[K]> {
  if (x == null || typeof x !== "object") return false;
  const hier = (globalThis as unknown as Record<string, unknown>)[art];
  if (typeof hier === "function" && x instanceof hier) return true;
  const knoten = x as { ownerDocument?: Document | null; defaultView?: Window | null };
  const win = knoten.ownerDocument?.defaultView ?? knoten.defaultView ?? null;
  const dort = win ? (win as unknown as Record<string, unknown>)[art] : undefined;
  return typeof dort === "function" && x instanceof dort;
}
